import React from "react";

import Lamina151 from "../images/lamina151.png";
import Lamina152 from "../images/lamina152.png";
import Lamina15actividad from "../images/lamina15actividad.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";
import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  blue: {
    color: theme.palette.blue.main,
    borderColor: theme.palette.blue.main,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
  rectangleYellow: {
    backgroundColor: "#ffcb05",
    padding: "5px 15px 5px 0",
    transform: "rotate(-5deg)",
    fontWeight: 500,
    margin: ".8em",
    "& ul": {
      paddingLeft: 30,
    },
    "& li": {
      marginBottom: ".5em",
    },
  },
  rectangleGreen: {
    backgroundColor: "#abd037",
    padding: "5px 15px 5px 0",
    transform: "rotate(-5deg)",
    fontWeight: 500,
    margin: ".8em",
    "& ul": {
      paddingLeft: 30,
    },
    "& li": {
      marginBottom: ".5em",
    },
  },
}));

const Lamina15 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 15: Normas de convivencia"
        meta={[
          {
            property: "og:title",
            content: "Lámina 15: Normas de convivencia",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "A veces en nuestras ciudades y barrios hay problemas que afectan nuestra vida en comunidad.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="15" color="blue" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="Normas de convivencia" color="blue" />
        <p>
          A veces en nuestras ciudades y barrios hay problemas que afectan
          nuestra vida en comunidad.
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="blue" />
        <p>
          <strong>
            Observa las siguientes imágenes y responde las preguntas de manera
            escrita o graba un audio con tus respuestas.
          </strong>
        </p>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={9} md={9} sm={6} xs={12}>
            <img src={Lamina151} alt="Normas de convivencia" />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className={classes.rectangleYellow}>
              <ul>
                <li>¿Qué dificultad observas en la imagen?</li>
                <li>
                  ¿Consideras que se están vulnerando los derechos de la niña?
                  ¿Por qué?
                </li>
                <li>¿Qué harías si ves una situación similar?</li>
              </ul>
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={9} md={9} sm={6} xs={12}>
            <img src={Lamina152} alt="Normas de convivencia" />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className={classes.rectangleGreen}>
              <ul>
                <li>¿Qué pasará si ambos autos siguen avanzando?</li>
                <li>¿Cómo se podría evitar eso?</li>
                <li>
                  ¿Crees que las personas en los puestos corren riesgo? ¿Por
                  qué?
                </li>
              </ul>
            </div>
          </Grid>
        </Grid>
        <p style={{ color: "#ef4136" }}>
          <strong>
            Para evitar problemas como estos, es importante que en los lugares
            donde vivimos existan normas que debemos cumplir para tener una
            mejor convivencia. Las normas nos ayudan a tener relaciones
            armoniosas con todas las personas, por eso las debemos cumplir
            siempre y en todo lugar, como en nuestra casa, la escuela, la
            localidad y nuestro país. Las normas y leyes han sido necesarias
            desde los inicios de nuestra historia para mantener el orden y la
            armonía en la sociedad.
          </strong>
        </p>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="EL RESPETO A LAS NORMAS" color="blue" />
        <br></br>
        <Actividad color="blue" />
        <p>
          <strong>Observa las siguientes imágenes y responde.</strong>
        </p>
        <p>
          ¿Cuál es el problema en cada una? Encierra en un círculo la respuesta
          que creas correcta.
        </p>
        <img src={Lamina15actividad} alt="Actividad" />
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <ul>
          <li>
            ¿Hay en tu localidad vecinas o vecinos que no respetan las normas?
          </li>
          <li>
            ¿De qué manera han solucionado o crees que puede solucionarse este
            tipo de situaciones?
          </li>
        </ul>
        <p style={{ color: "#00aeef" }}>
          <strong>
            Si te das cuenta, en el último caso, la norma está escrita y visible
            en un cartel, pero no está siendo respetada. Por eso, no basta saber
            que existen normas, lo más importante es el compromiso de los
            ciudadanos por respetarlas y cumplirlas. Así tendremos un país más
            justo y armonioso.
          </strong>
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-15.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.blue }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 15: Normas de convivencia'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Derecho de los niños y las niñas"
        anteriorEnlace="/lamina-1-14"
        siguiente="Valores para la convivencia en familia"
        siguienteEnlace="/lamina-1-16"
      />
    </>
  );
};

export default Lamina15;
